import { connect } from 'formik';
import React, { FC, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FiXCircle } from 'react-icons/fi';
import { ReactComponent as IconUpload } from '../../icons/upload.svg';
import { StyledErrorMessage } from '../base/forms/formikFieldWrapper.styles';
import { Label } from '../base/forms/label';
import { H6, P } from '../base/typography';
// import { IStepInfoAboutDamage } from '../../stepInfoAboutDamage.schema';
import * as StyledUploadFiles from './uploadFiles.styles';

interface Props {
	label?: string;
	smallLabel?: boolean;
	name: string;
	formik?: any;
}

const UploadFiles: FC<Props> = ({ label, smallLabel, name, formik }) => {
	const { t } = useTranslation('generalForm');
	const { errors, submitCount, setFieldValue, values } = formik;
	const [files, setFiles] = useState(values[name]);
	const [showErrorMessage, setErrorMessage] = useState(false);

	const removeFile = fileToRemove => {
		const indexToRemove = files.findIndex(item => fileToRemove === item.name);
		files.splice(indexToRemove, 1);
		setFieldValue('files', [...files]);
		setFiles([...files]);
	};

	const errorMessage = () => {
		setErrorMessage(true);
		setTimeout(() => {
			setErrorMessage(false);
		}, 3000);
	};

	const onDrop = useCallback(
		(acceptedFiles, rejectedFiles) => {
			setFiles([...files, ...acceptedFiles]);
			setFieldValue(name, [...files, ...acceptedFiles]);
			if (rejectedFiles.length > 0) {
				errorMessage();
			}
		},
		[files, setFieldValue, name]
	);

	// @ts-ignore
	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		accept: '.png, .jpg, .jpeg, .gif, .bmp, .doc, .docx, .txt, .pdf',
		maxSize: 25000000,
        minSize: 1,
	});

	return (
		<StyledUploadFiles.Wrapper>
			{label && (
				<Label small={smallLabel} htmlFor={name}>
					{label}
				</Label>
			)}
			<StyledUploadFiles.DragNDrop>
				<StyledUploadFiles.DragNDropSection {...getRootProps()}>
					<StyledUploadFiles.DragNDropInput {...getInputProps()} />
					<IconUpload />
					<StyledUploadFiles.TextSection>
						<H6>{t('dragFilesHere')}</H6>
						<P>{t('allowedFiles')}</P>
					</StyledUploadFiles.TextSection>
				</StyledUploadFiles.DragNDropSection>
			</StyledUploadFiles.DragNDrop>
			{showErrorMessage && <StyledErrorMessage>{t('fileNotallowed')}</StyledErrorMessage>}
			<StyledUploadFiles.FileListContainer>
				{files &&
					files.map((item, index) => (
						<StyledUploadFiles.FileList key={index}>
							<P>{item.name}</P>
							<FiXCircle onClick={() => removeFile(item.name)} />
						</StyledUploadFiles.FileList>
					))}
			</StyledUploadFiles.FileListContainer>
			{errors[name] && submitCount > 0 && (
				<StyledUploadFiles.StyledErrorMessage>{t(errors[name])}</StyledUploadFiles.StyledErrorMessage>
			)}
		</StyledUploadFiles.Wrapper>
	);
};

export default connect(UploadFiles);
